var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-toggler"},_vm._l((_vm.toggleItems),function(item){return _c('div',{key:item,staticClass:"tab-toggler--item",class:{ 'is-active text-primary': _vm.currentNavMode === item },on:{"click":function($event){return _vm.$emit('toggle-nav-mode', item)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }